import { Typography } from 'antd';
import React, { CSSProperties } from 'react';

const MoneyRow = ({
  leftText,
  rightText,
  strong,
  style,
  leftTextStyle,
  rightTextStyle,
}: {
  leftText: string;
  rightText: number | string;
  strong?: boolean;
  style?: CSSProperties;
  leftTextStyle?: CSSProperties;
  rightTextStyle?: CSSProperties;
}) => {
  return (
    <div className="row-between-center" style={style}>
      <Typography.Text strong={strong} style={leftTextStyle}>
        {leftText}
      </Typography.Text>
      <Typography.Text strong={strong} style={rightTextStyle}>
        {rightText}
      </Typography.Text>
    </div>
  );
};

export default MoneyRow;
